'use client';

import { Collapse as FreddyCollapse } from '@coolblue-development/freddy';
import type { ResolvedGA4Trigger } from '@coolblue-development/ga4-events';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  trackingExpandedTrigger: ResolvedGA4Trigger;
  trackingCollapsedTrigger: ResolvedGA4Trigger;
  collapsedLength: number;
};

export default function Collapse({
  children,
  trackingExpandedTrigger,
  trackingCollapsedTrigger,
  collapsedLength
}: Props) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();
  const freddyCollapseTranslations = useFreddyTranslations('collapse');

  const collapseTranslations = {
    labelCollapsed: t('filterPage.numberMore', {
      number: collapsedLength
    }),
    labelExpanded: freddyCollapseTranslations.labelExpanded
  };

  function handleToggle(isOpen: boolean) {
    if (isOpen) {
      trackEvent(trackingExpandedTrigger);
    } else {
      trackEvent(trackingCollapsedTrigger);
    }
  }

  return (
    <FreddyCollapse
      translations={collapseTranslations}
      onToggle={handleToggle}
      togglePosition='top'
    >
      {children}
    </FreddyCollapse>
  );
}
